import React, { FunctionComponent, useEffect, useState } from 'react';
import LoginLeftSection from 'components/loginLeftSection/LoginLeftSection';
import Button from 'components/button/Button';
import CheckBox from 'components/checkBox/CheckBox';
import Styles from './StepFour.module.scss';
import { useHistory, useLocation } from 'react-router';
import getItemFromLocalStorage from 'utils/getItemFromLocalStorage';

interface StepFourProps {
  loginRequest: Function;
  userRegistrationRequest: Function;
}
const StepFour: FunctionComponent<StepFourProps> = (props: StepFourProps) => {
  const { loginRequest, userRegistrationRequest } = props;
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [checked, setChecked] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const history = useHistory();
  const location = useLocation<{ profileImage?: File | null }>();
  const profileImage = location.state?.profileImage;
  const handleChange = (event: any) => {
    setChecked(event.target.checked);
  };
  const handleDone = () => {
    const user = getItemFromLocalStorage('userObj');
    if (user === null) {
      return;
    }

    // First, register the user
    const data = new FormData();
    data.append('name', user.name);
    data.append('email', user.email);
    data.append('password', user.password);
    if (profileImage) {
      data.append('profile_pic', profileImage);
    }
    if (user.token) {
      data.append('token', user.token);
    }

    userRegistrationRequest(data);

    // Then login
    loginRequest({
      email,
      password,
    });

    if(user) {
      history.push('/conversations-nearby');
    } else {
      history.go(0);
    }
  };
  useEffect(() => {
    if (checked) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [checked]);

  useEffect(() => {
    setEmail(JSON.parse(localStorage.getItem('userObj') as string).email)
    setPassword(JSON.parse(localStorage.getItem('userObj') as string).password)
  }, []);
  return (
    <section className={Styles.customContainer}>
      <div className={Styles.leftSectionWrapper}>
        <LoginLeftSection />
      </div>
      <div className={Styles.rightSectionWrapper}>
        <div className={Styles.loginArea}>
          <h5 className="fontTwenty font-weight-500 text-black text-uppercase">Step 4</h5>
          <p className={`mb-40 ${Styles.profileTitle}`}>
            Agree to Social Play&nbsp;
            {'>'}
            &nbsp;<a href="#" onClick={(e) => { e.preventDefault(); }}>guidelines</a>
          </p>
          <p>
            To use Social Play you must be at least 18 years old. The culture of Social Play is welcoming and inclusive to everyone. The general conversation guidelines are PG-13.
          </p>
          <p className="mt-30 fontSixteen mb-0">
            Social Play will need to use your approximate location to load nearby chat rooms. 
            Allow Social Play to use your location, microphone, and camera in your browser permissions to utilize all of the chat room features. 
            Social Play will not ask for your home address and we don't recommend disclosing it. 
            If you have any questions post them in the Welcome to Social Play chat room and we will help you. 
            Welcome to this great community.  We're looking forward to chatting with you.
            <br />
            <span className="font-weight-600">Just have fun and join the conversation!</span>
          </p>
          <div className={Styles.checkboxWrapper}>
            <CheckBox
              id="agreeCheckbox"
              label="I agree to the terms and conditions"
              handleChange={handleChange}
            />
          </div>
          <Button 
            clickHandler={handleDone} 
            cssClass={Styles.confirmEmailBtn} 
            label="Agree" 
            disabled={disabled}
          />
        </div>
      </div>
    </section>
  );
};
export default StepFour;
